import React from 'react'
import List from '@material-ui/core/List';

export default function ZList(props) {
    return (
        <List {...props}>
            {props.children}
        </List>
    )
}
